/**
 * Dependencies.
 */
import { BaseModel, prop } from '@prz-dp/services';

/**
 * Enum `CampaignTypeEnum`.
 */
export enum CampaignTypeEnum {
  COUPON_FIXED = 'COUPON_FIXED',
  COUPON_PERCENTAGE = 'COUPON_PERCENTAGE',
  DISCOUNT_ON_PRODUCT = 'DISCOUNT_ON_PRODUCT',
  GENERIC = 'GENERIC',
  OFFER = 'OFFER',
  PACK_PURCHASE = 'PACK_PURCHASE',
  PRODUCT_OFFER = 'PRODUCT_OFFER'
}

/**
 * Constant `ON_DEMAND_CAMPAIGN_TYPES`.
 */
export const ON_DEMAND_CAMPAIGN_TYPES: CampaignTypeEnum[] = [
  CampaignTypeEnum.COUPON_FIXED,
  CampaignTypeEnum.COUPON_PERCENTAGE,
  CampaignTypeEnum.DISCOUNT_ON_PRODUCT,
  CampaignTypeEnum.PACK_PURCHASE,
  CampaignTypeEnum.PRODUCT_OFFER
];

/**
 * Model `CampaignForPartnershipModel`.
 */
export class CampaignForPartnershipModel extends BaseModel {
  @prop()
  baseModelCode: string;

  @prop()
  campaignType:
  | 'COUPON_FIXED'
  | 'COUPON_PERCENTAGE'
  | 'DISCOUNT_ON_PRODUCT'
  | 'OFFER'
  | 'PACK_PURCHASE'
  | 'PRODUCT_OFFER';

  @prop()
  maxDurationDays: number;

  @prop()
  minDurationDays: number;

  @prop()
  name: string;

  @prop()
  repeatSameDays: number;

  @prop()
  repeatTypeDays: number;

  @prop()
  restrictionDaysRepeatType: number;

  @prop()
  dailyUsageLimit: number;

  /**
   * Constructor.
   */
  constructor(data?: Partial<CampaignForPartnershipModel>) {
    super(data);
  }
}
